import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

function hideStartupLoader(): void {
  const loader = document.getElementById('startup-loader');
  if (!loader) return;
  loader.classList.add('hidden');
  window.setTimeout(() => loader.remove(), 400);
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err))
  .finally(() => hideStartupLoader());



